import type { TypographyProps } from './Typography';
import { Typography } from './Typography';

export type TextMenuHeaderProps = Pick<
  TypographyProps,
  'label' | 'color' | 'ellipsis'
>;

export const TextMenuHeader = ({
  label,
  color = 'text-ds-natural',
  ellipsis,
}: TextMenuHeaderProps) => (
  <Typography
    uppercase
    color={color}
    label={label}
    tagName="span"
    fontSize="text-ds-100"
    lineHeight="leading-ds-200"
    fontWeight="font-ds-medium"
    letterSpacing="tracking-ds-wider"
    ellipsis={ellipsis}
  />
);
